import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import * as Actions from '../../actions/actions';

class Confirm extends Component {
  constructor(props) {
    super(props);
    const { confirm, location: { search }, history } = props;
    const parsed = queryString.parse(search);
    if (parsed.oobCode) {
      setTimeout(() => confirm(parsed.oobCode, history), 3000);
    }
  }

  render() {
    const { location: { search }, currentUserVm: { email } } = this.props;
    const parsed = queryString.parse(search);
    return (
      <div className="confirm">
        {parsed && parsed.oobCode ? (
          <p>Vielen Dank! Ihr Account wird gerade bestätigt. </p>) :
          (<p>Ihnen wird in kürze eine E-Mail an {email} gesendet.</p>)}
        <Link to="/">Zurück zur Startseite</Link>
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.currentUserReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(withRouter(Confirm));



// WEBPACK FOOTER //
// ./src/pages/Confirm/index.js